import { SET_IS_NEW_RECORD } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (value) => companyUsersActions[SET_IS_NEW_RECORD](value);
